module.exports = __webpack_public_path__ + "static/media/service-img-04.f982dced.png";